<template>
  <div class="pagination-wrapper">
    <nav class="pager" role="navigation" aria-labelledby="pagination-heading">
      <h4 class="pagination-heading visually-hidden">{{ Drupal.t('Pagination') }}</h4>

      <ul class="pagination">
        <li class="pager__item--first" v-if="!isInFirstPage">
          <a
            href="#"
            title="{{ Drupal.t('Go to first page') }}"
            class="page-link page__first"
            rel="prev"
            @click="onClickFirstPage"
          >
            {{ Drupal.t("First") }}
          </a>
        </li>
        <li class="pager__item--previous" v-if="!isInFirstPage">
          <a
            href="#"
            title="{{ Drupal.t('Go to previous page') }}"
            class="page-link page__previous"
            rel="prev"
            @click="onClickPreviousPage"
          >
            {{ Drupal.t("Previous") }}
          </a>
        </li>

        <li v-for="page in pages" class="page-item" :key="page.name" :class="{ active: isPageActive(page.name) }">
          <span v-if="isPageActive(page.name)" class="page-link">{{ page.name }}</span>
          <a
            v-else
            href="#"
            title="{{ Drupal.t('Go to page @key', {'@key': page.name }) }}"
            class="page-link"
            @click="onClickPage(page.name, $event)"
          >{{ page.name }}</a>
        </li>

        <li class="pager__item--next" v-if="!isInLastPage">
          <a
            href="#"
            title="{{ Drupal.t('Go to next page') }}"
            class="page-link page__next"
            rel="next"
            @click="onClickNextPage"
          >
            {{ Drupal.t("Next") }}
          </a>
        </li>
        <li class="pager__item--last" v-if="!isInLastPage">
          <a
            href="#"
            title="{{ Drupal.t('Go to last page') }}"
            class="page-link page__last"
            rel="prev"
            @click="onClickLastPage"
          >
            {{ Drupal.t("Last") }}
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  data() {
    return {
      Drupal: this.$drupal,
    }
  },
  props: {
    count: {
      type: Number,
      required: true
    },
    resultCount: {
      type: Number,
      required: true
    },
    maxVisibleButtons: {
      type: Number,
      required: false,
      default: 3
    },
    totalPages: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    maxPageRange: {
      type: Number,
      required: false,
      default: 3
    }
  },
  computed: {
    isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage() {
      return this.currentPage === this.totalPages;
    },
    startPage() {
      return this.currentPage;
    },
    pageResultStart() {
      return ((this.currentPage - 1) * this.perPage) + 1
    },
    pageResultEnd() {
      return ((this.currentPage - 1) * this.perPage) + this.resultCount
    },
    pages() {
      const range = [];

      for (
        let i = 1;
        i <= this.totalPages;
        i++
      ) {
        if (i >= (this.currentPage - this.maxPageRange) && i <= (this.currentPage + this.maxPageRange)) {
          range.push({
            name: i,
            isDisabled: i === this.currentPage
          });
        }
      }

      return range;
    },
  },
  methods: {
    onClickFirstPage(event) {
      this.$emit('pagechanged', 1);
      event.preventDefault()
    },
    onClickPreviousPage(event) {
      this.$emit('pagechanged', this.currentPage - 1);
      event.preventDefault()
    },
    onClickPage(page, event) {
      this.$emit('pagechanged', page);
      event.preventDefault()
    },
    onClickNextPage(event) {
      this.$emit('pagechanged', this.currentPage + 1);
      event.preventDefault()
    },
    onClickLastPage(event) {
      this.$emit('pagechanged', this.totalPages);
      event.preventDefault()
    },
    isPageActive(page) {
      return this.currentPage === page;
    }
  }
}
</script>
